// extracted by css-extract-rspack-plugin
export default {"PermissionTableContainer":"kwa1F"};